module.exports = __webpack_public_path__ + "static/media/razor-hair-salon-tool.f91e18eb.svg";